import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useGroup } from '../contexts/GroupContext';
import { pagesFor, pathFor, placeOf } from './map';
import { cachedAccess, roleOf } from './access';

// Where a section page stands: its section, its page, the space, and how to
// move to a sibling page (keeping nothing of the query — a new page starts clean).
export function usePlace() {
    const location = useLocation();
    const navigate = useNavigate();
    const { activeGroupId, activeGroup } = useGroup();
    const groupId = activeGroupId || null;
    // the role here: what my-access answered (once read, nucleus/access.js), else
    // the roster's; null in your own space
    const rosterRole = activeGroup?.my_role || activeGroup?.role || null;
    const role = groupId ? roleOf(cachedAccess(groupId, rosterRole), rosterRole) : null;
    const { section, page } = placeOf(location.pathname, groupId);
    const go = useCallback((pageId, query = '') => {
        navigate(`${pathFor(section.id, pageId, groupId)}${query ? `?${query}` : ''}`);
    }, [navigate, section, groupId]);
    const to = useCallback((sectionId, pageId, query = '') => (
        `${pathFor(sectionId, pageId, groupId)}${query ? `?${query}` : ''}`
    ), [groupId]);
    return {
        section,
        page,
        // a member is not shown an admin's pages (map.js)
        pages: section ? pagesFor(section, groupId, { admin: !groupId || role === 'admin' }) : [],
        groupId,
        group: activeGroup || null,
        role,
        isAdmin: !groupId || role === 'admin',
        spaceName: groupId ? (activeGroup?.name || 'this group') : 'Self',
        // for a collection's title: " in Studio" in a group, nothing in your own space
        inSpace: groupId ? ` in ${activeGroup?.name || 'this group'}` : '',
        go,
        to,
        navigate,
    };
}
